// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_G-K","cls2":"SimplePaperPodcast-cls2_MZq SimplePaperPodcast-cls1_G-K"};